import React from 'react';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import { getHtmlImages } from '~/services/util';

const SearchResult = ({ blogs, search, onClick, onCancel, onSearch }) => {
    const { current_page, data, last_page, per_page, total } = blogs;
    return (
        <div className="blog-search-result">
            <p className="dsl-b20 bold">Search Results</p>
            <div className="search-chip" onClick={onCancel}>
                <span className="dsl-b14">{search}</span>
                <Icon name="fas fa-xmark cursor-pointer ms-2" color="#343f4b" size={14} />
            </div>
            {total > 0 ? (
                <>
                    {data.map((item) => {
                        const { id, name, author, author_avatar, updated_at, data } = item;
                        const authorName = `${author?.first_name} ${author?.last_name}`;
                        const thumbnail = getHtmlImages(data.body)[0];
                        return (
                            <div className="d-flex ssm-column mt-3" key={`p${id}`} onClick={onClick(item)}>
                                <div className="blog-thumbnail w-30 ms-3">
                                    {thumbnail && thumbnail.match(/<img/) ? <div dangerouslySetInnerHTML={{ __html: thumbnail }} /> : <Thumbnail source={thumbnail} size="responsive" />}
                                </div>
                                <div className="ml-3 ssm-100 w-70">
                                    <p className="dsl-b16 bold mb-2">{name}</p>
                                    {data.body && (
                                        <ShowMoreText lines={3} more="Read more" less="Read less">
                                            <div dangerouslySetInnerHTML={{ __html: data.body.replace(/<img[^>]+>/g, '') }} />
                                        </ShowMoreText>
                                    )}
                                    <div className="d-flex mt-3">
                                        <Avatar url={author_avatar} isSponsored={true} />
                                        <div className="ml-2">
                                            <p className="dsl-m12 mb-1">{authorName}</p>
                                            <p className="dsl-b12 mb-0">{author?.profile?.company}</p>
                                        </div>
                                        <span className="dsl-m12 ms-auto">{moment(updated_at).format('MMM DD, YY')}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div className="d-h-start">
                        <Pagination current={current_page} per={per_page} pers={[]} total={last_page} onChange={onSearch} />
                    </div>
                </>
            ) : (
                <div className="dsl-b16 text-center pb-3">No search result available</div>
            )}
        </div>
    );
};

SearchResult.propTypes = {
    blogs: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        last_page: PropTypes.number,
        per_page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    search: PropTypes.string,
    onClick: PropTypes.func,
    onCancel: PropTypes.func,
    onSearch: PropTypes.func,
};

SearchResult.defaultProps = {
    blogs: {
        current_page: 1,
        data: [],
        last_page: 1,
        per_page: 10,
    },
    search: '',
    onClick: () => {},
    onCancel: () => {},
    onSearch: () => {},
};

export default SearchResult;
